<template>
  <div id="yandex-map" class="ymap"></div>
</template>

<script>
import restfulApi from "@/api/restfulApi";

export default {
  name: "Ymap",
  props: {
    markers: {
      default: []
    },
    zoom: {
      type: [Number, String]
    },
    center: {
      type: Array
    }

  },
  mounted() {
    if (!window.ymaps) {
      const ymapScript = document.createElement('script');
      ymapScript.src = `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${restfulApi.getToken('yandex_map')}`;
      document.head.append(ymapScript);
      ymapScript.onload = () => {
        if (!this.map) {
          this.initializeYandexMap()
        }
      }
    } else {
      if (!this.map) {
        this.initializeYandexMap()
      }
    }
  },
  data() {
    return {
      yMap: {
        defaultCenter: [59.93, 30.31],
        defaultZoom: 10,
        defaultSelectedZoom: 17
      }
    }
  },
  methods: {
    initializeYandexMap() {
      window.ymaps.ready(() => {
        this.map = new window.ymaps.Map("yandex-map", {
          center: this.yMap.defaultCenter,
          zoom: this.yMap.defaultZoom,
          controls: ['geolocationControl', 'zoomControl'],
          searchControlProvider: 'yandex#search'
        })
        if (this.markers) {
          this.setMarkers(this.markers)
        }
      })
    },
    setMarkers(markers) {
      if (!this.map) {
        return false
      }
      this.map.geoObjects.removeAll()

      markers.forEach(marker => {
        let balloon
        if (marker.address && marker.id) {
          balloon = {
            balloonContentLayout: this.createBalloon(marker.address, marker.id),
            balloonPanelMaxMapArea: 0
          }
        }
        this.map.geoObjects.add(new window.ymaps.Placemark(
          marker.coordinates,
          {
            iconCaption: marker.name || ''
          },
          balloon
        ))
      })

      if (markers.length === 0) {
        return
      }

      if (markers.length === 1) {
        this.setCenter(markers[0].coordinates)
        this.setZoom(this.yMap.defaultSelectedZoom)
        return
      }

      const {center, zoom} = window.ymaps.util.bounds.getCenterAndZoom(
        this.map.geoObjects.getBounds(),
        this.map.container.getSize()
      )
      this.setCenter(center)
      this.setZoom(zoom - 1)

    },
    createBalloon(address, id) {
      const componentContext = this
      const BalloonContentLayout = window.ymaps.templateLayoutFactory.createClass(
        `<div class="balloon-content">
                    <button id="counter-button" class="btn btn-link">${address}</button>
                </div> `, {
          build() {
            BalloonContentLayout.superclass.build.call(this)
            document.getElementById('counter-button').addEventListener('click', this.onCounterClick)
          },

          clear() {
            BalloonContentLayout.superclass.clear.call(this)
          },

          onCounterClick() {
            componentContext.goToHouse(id)
          }
        })
      return BalloonContentLayout
    },
    setZoom(val = this.yMap.defaultZoom) {
      this.map.setZoom(val)
    },
    setCenter(val = this.yMap.defaultCenter) {
      this.map.setCenter(val)
    },
    goToHouse(houseId) {
      this.$router.push({name: 'HouseElements', params: {houseId}})
    }
  },
  watch: {
    markers: {
      handler(val) {
        this.setMarkers(val)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.ymap {
  min-height: 300px;
  border-radius: 20px;
  overflow: hidden;
}
</style>

<style>
.balloon-content {
  max-width: 200px;
}

.balloon-content button {
  font-size: inherit;
  text-align: left;
  padding: 0;
  border-radius: 0;
}
</style>
